<template>
  <div class="box mybookings-box z-depth-1">
    <div class="container">
      <img class="material-icons" :src="$mobileCdn('images/icons/icon-new-car.svg')" alt="Telefone">
      <span>{{ $t('customer.mybookingsDesc') }}</span>
      <router-link :to="{name: $routeResolver('routes.customer.booking.details'), params: { bookingCode }}" class="btn white w100 lowcase waves-effect btn-color-black">
        <i class="material-icons mr-0">chevron_right</i> {{ $t('customer.mybooks') }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Mybookingsbox',

  computed: {
    bookingCode() {
      return this.$route.params.bookingCode
    }
  }
}

</script>

<style lang="scss">
    .mybookings-box {
        span {
            display: inline-block !important;
            font-size: 15px;
            vertical-align: middle;
            line-height: normal;
            width: 82%;
        }

        .material-icons {
            display: inline-block;
            margin-right: 20px;
            font-size: 2.6em;

            &.mr-0 {
              margin-right:0;
            }
        }

        .btn {
            margin-top: 15px;
        }
        .btn-color-black{
          text-align: left;
          margin-left: 40px;
          color: $color-black!important;
          font-weight: 500;

          .material-icons {
            color: $color-black!important;
            font-size: 23px;
          }
        }
    }
</style>
